import styled from "styled-components";

const ActivityAction = styled.div`
  color: #595959;
  cursor: pointer;
  text-decoration: underline;
`

export default ActivityAction